import React, { useEffect } from 'react';
import { StoreButtons } from './landing/StoreButtons';
import './landing/landing.css';

const KEEP = new Set(['shiftready:lang']);

// The web version is no longer a standalone app. Clear any shift data a past web session left behind.
const clearOldWebShiftData = () => {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith('shiftready:') && !KEEP.has(k))
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
};

export default function GetTheApp() {
  useEffect(() => {
    clearOldWebShiftData();
    document.title = 'Get ShiftReady for iPhone and Android';
  }, []);

  return (
    <div className="lp lp-getapp" data-testid="get-the-app-page">
      <main className="lp-wrap lp-getapp__inner">
        <a href="/" className="lp-brand" data-testid="get-app-home-link">
          <img src="/landing/icon.webp" alt="" width="40" height="40" /><span>ShiftReady</span>
        </a>
        <h1 className="lp-h1" data-testid="get-app-title">ShiftReady lives on <em>your phone.</em></h1>
        <p className="lp-lead">
          ShiftReady is available for iPhone and Android. Start with a 7-day free trial, then $7.99/month. Cancel anytime in the App Store or Google Play.
        </p>
        <div className="lp-ctas" data-testid="get-app-store-buttons">
          <StoreButtons prefix="get-app" showWebButton={false} />
        </div>
        <p className="lp-getapp__note">
          Your shift notes stay on your phone, not on our servers. <a href="/privacy" data-testid="get-app-privacy-link">Privacy Policy</a> · <a href="/terms" data-testid="get-app-terms-link">Terms</a>
        </p>
      </main>
    </div>
  );
}
